import Dexie, { type EntityTable } from 'dexie'
import type { DayData } from './types.js'
import type { QueueOperation } from './sync-model.js'

export type Draft = { entityKey: string; date: string; payload: Record<string, unknown>; updatedAt: number; storageOk: boolean }
export type CachedDay = { date: string; data: DayData; fetchedAt: number }

class LedgerDatabase extends Dexie {
  drafts!: EntityTable<Draft, 'entityKey'>
  operations!: EntityTable<QueueOperation, 'operationId'>
  days!: EntityTable<CachedDay, 'date'>
  constructor() {
    super('zaocan-ledger-v1')
    this.version(1).stores({ drafts: '&entityKey,date,updatedAt', operations: '&operationId,entityKey,state,createdAt', days: '&date,fetchedAt' })
  }
}

export const db = new LedgerDatabase()
